import React, { useEffect, useState } from "react";
import "./Carousel.css"; // Add this CSS file for styles
import { Modal } from "react-bootstrap";

const TrophyCarousel = ({ trophies }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [slidesPerView, setSlidesPerView] = useState(4);
  const [showModal, setShowModal] = useState(false);
  const [awardTitle, setawardTitle] = useState("");
  const [selectedTrophy, setSelectedTrophy] = useState(null); // ✅ New state for selected trophy
  useEffect(() => {
    const updateSlidesPerView = () => {
      if (window.innerWidth <= 575) {
        setSlidesPerView(1);
      } else if (window.innerWidth <= 767) {
        setSlidesPerView(2);
      } else if (window.innerWidth <= 991) {
        setSlidesPerView(3);
      } else {
        setSlidesPerView(4);
      }
    };

    updateSlidesPerView();
    window.addEventListener("resize", updateSlidesPerView);

    return () => {
      window.removeEventListener("resize", updateSlidesPerView);
    };
  }, []);

  const goToNext = () => {
    setActiveIndex((prevIndex) =>
      Math.min(prevIndex + 1, trophies?.length - slidesPerView)
    );
  };

  const goToPrev = () => {
    setActiveIndex((prevIndex) => Math.max(prevIndex - 1, 0));
  };

  return (
    <>
      <div
        id="carouselExample"
        className="carousel slide"
        data-bs-ride="carousel"
      >
        <div className="carousel-inner">
          <div className="carousel-item active">
            <div
              className="carousel-items-container"
              style={{
                transform: `translateX(-${
                  (activeIndex * 100) / slidesPerView
                }%)`,
                transition: "transform 0.5s ease",
              }}
            >
              {trophies?.map((trophy, index) => (
                <div
                  className="col-6 col-md-3 d-flex justify-content-center mb-3"
                  key={index}
                >
                  <div className="text-center">
                    <div className="award-container position-relative">
                      <img
                        src={
                          trophy?.is_awarded
                            ? "https://d2lvj32mp5x83n.cloudfront.net/static/parentadmin/award/trophy/trophycover.png"
                            : "https://d2lvj32mp5x83n.cloudfront.net/static/parentadmin/award/trophy/trophydisable.png"
                        }
                        alt="border"
                        className="img-fluid award-frame w-100"
                        style={{
                          opacity: trophy?.is_awarded ? 1 : 1,
                          filter: trophy?.is_awarded ? "none" : "",
                          transition:
                            "opacity 0.3s ease-in-out, filter 0.3s ease-in-out",
                        }}
                      />
                      <div className="award-image-wrapper position-absolute top-50 start-50 translate-middle">
                        <img
                          src={trophy?.trophyFile}
                          alt="award"
                          className="img-fluid award-image object-fit-contain"
                          style={{
                            maxWidth: "90%",
                            maxHeight: "90%",
                            opacity: trophy?.is_awarded ? 1 : 0.5,
                            filter: trophy?.is_awarded
                              ? "none"
                              : "grayscale(50%)",
                            transition:
                              "opacity 0.3s ease-in-out, filter 0.3s ease-in-out",
                          }}
                          onClick={() => {
                            if (trophy?.is_awarded) {
                              setShowModal(true);
                              setawardTitle(trophy?.title);
                              setSelectedTrophy(trophy); // ✅ Set selected trophy
                            }
                          }}
                        />
                        {!trophy?.is_awarded && (
                          <img
                          src="https://d2lvj32mp5x83n.cloudfront.net/static/parentadmin/award/LockIcon.png"
                          alt="lock"
                            className="img-fluid allow-image object-fit-contain position-absolute"
                            style={{
                              maxWidth: "50%",
                              top: "50%",
                              left: "50%",
                              transform: "translate(-50%, -50%)",
                            }}
                          />
                        )}
                      </div>
                    </div>
                    <p
                      className="text-white"
                      style={{ fontSize: "20px", fontWeight: "600" }}
                    >
                      {trophy?.title}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <button
          className="carousel-control-prev"
          type="button"
          onClick={goToPrev}
        >
          <span
            className="carousel-control-prev-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          onClick={goToNext}
        >
          <span
            className="carousel-control-next-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        size="lg"
        className="modal-dialog-centered trophy-modal"
      >
        <Modal.Header className="text-white">
          <Modal.Title className="w-100 text-center text-white fs-4">
            {awardTitle}
          </Modal.Title>
          <i className="bi bi-x fs-4" onClick={() => setShowModal(false)}></i>
        </Modal.Header>
        <Modal.Body className="d-flex justify-content-center align-items-center p-0">
          <div className="trophy-content">
            {selectedTrophy && (
              <img
                className="TrphyModalFile"
                src={selectedTrophy?.trophyFile}
                alt="award"
              />
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default TrophyCarousel;
